export enum UnitValueType {
  Years = 'years',
  Months = 'months',
}

export type UnitValue = {
  value: string | number;
  unit: UnitValueType | string;
};
